import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import EventExportPopup from "@/components/Events/EventExportPopup/EventExportPopup.vue";
import PickLocation from "@/components/Admin/PickLocation/PickLocation.vue";
import "./PrincipalsAdmin.scss";
import { destroyFile, getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import Vue from "vue";
import { debounce } from "lodash";
import NewsDetailViewCustomizerDialog from "@/components/News/NewsDetailViewCustomizerDialog/NewsDetailViewCustomizerDialog.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ColorPickerButton from "@/components/Common/ColorPickerButton/ColorPickerButton.vue";
import {
  getDefaultContentTypes,
  updateAllNewsInApp
} from "@/helpers/newsHelper";
import { uploadFile } from "@/helpers/fileHelper";
export default {
  name: "PrincipalsAdmin",
  components: {
    ColorPickerButton,
    TreeViewSelection,
    LogOverview,
    NewsDetailViewCustomizerDialog,
    AdminList,
    EventExportPopup,
    PickLocation
  },
  data: () => ({
    isValid: false,
    dialog: false,
    dragging: false,
    dialogDelete: false,
    changedCopyrightField: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: false,
    defaultFilter: { searchText: "", itemsPerPage: 25 },
    filter: {},
    fileTypes: [{ text: "Tagungsbroschüre", value: "conferenceFile" }],
    headers: [
      { text: "Titel", value: "name" },
      { text: "Id", value: "id" },
      { text: "Aktionen", value: "actionChange", sortable: false }
    ],
    regionAccessRights: [
      { value: "read", text: "Lesen" },
      { value: "write", text: "Schreiben" },
      { value: "admin", text: "Admin" },
      { value: "status", text: "Status" }
    ],
    customizeDialog: false,
    refreshKey: 0,
    editedItem: {
      active: true,
      adminMailAddresses: [],
      description: "",
      id: "",
      isSub: false,
      modules: [],
      name: "",
      parent: {},
      subPrincipals: [],
      users: [],
      modulePreviewApiKeys: {
        kis: "",
        lastminute: "",
        pois: "",
        events: "",
        news: ""
      },
      additional_data: {
        poiImageTypes: [],
        companyCode: "",
        posCode: "",
        salesChannelId: "",
        topLocationRangeCode: "",
        topLocationRangeId: "",
        importPois: true,
        importInactivePois: true,
        importEvents: true
      },
      isChatbotEnabled: false,
      chatbotApiKey: ""
    },
    defaultItem: {
      active: true,
      showCopyright: true,
      description: "",
      id: "",
      isSub: false,
      modules: [],
      name: "",
      parent: {},
      users: [],
      additional_data: { poiImageTypes: [] },
      newsContentTypes: getDefaultContentTypes([]),
      modulePreviewApiKeys: {
        kis: "",
        lastminute: "",
        pois: "",
        events: "",
        news: ""
      },
      isChatbotEnabled: false,
      chatbotApiKey: ""
    },
    exportPopupIsOpen: false,
    editedExportConfig: {
      config: [],
      title: ""
    },
    editedIndex: -1,
    modules: {
      admin: "628b5e26e06088f80f9dc959",
      anzeigenassistent: "628b5e26e06088f80f9dc95b",
      typo3: "628b5e26e06088f80f9dc974",
      news: "628b5e26e06088f80f9dc967",
      locations: "628b5e26e06088f80f9dc965",
      poi: "628b5e26e06088f80f9dc96c",
      events: "628b5e26e06088f80f9dc960",
      web2print: "628b5e26e06088f80f9dc976",
      booking: "668fbc56c2357d0614103630",
      kis: "662a42822dcdc9021cc2e515",
      defects: "6715f40094e42d139c1ec348",
      prompt: "68594e10a4439c6de5535944",
      adManager: "68594e10a4439c6de5519402",
      maps: "69b7b6d7ae2eef4d01afccf6",
      formBuilder: "69d8c33409b0d184769c8669"
    },
    destinationOneTypes: {
      pois: ["POI", "Gastro"],
      events: ["Event"]
    },
    showNikiRecipients: false,
    nikiRecipients: "",
    promptFeeds: [],
    llmApiKeys: [],
    advertisingZones: [],
    appdinxLoginInitialAdvertising: {},
    defaultColorPalette: {
      news: {
        titel: "News",
        widget: {
          title: "Nachrichten-Widget",
          colors: [
            { label: "Primärfarbe", key: "color-primary", value: "#00636C" },
            {
              label: "Sekundärfarbe",
              key: "color-secondary",
              value: "#00636C"
            },
            { label: "Textfarbe", key: "color-text", value: "#333" },
            { label: "Akzentfarbe", key: "color-accent", value: "#00636C" },
            { label: "Fehlerfarbe", key: "color-error", value: "#ff0000" },
            { label: "Infofarbe", key: "color-info", value: "#50727C" },
            { label: "Warnfarbe", key: "color-warning", value: "#E4CC37" }
          ]
        },
        newsIssuesWidget: {
          title: "Ausgaben-Widget",
          colors: [
            { label: "Buttonfarbe", key: "color-button", value: "#00636C" },
            {
              label: "Hintergrundfarbe",
              key: "color-background",
              value: "#00636C"
            },
            { label: "Textfarbe", key: "color-text", value: "#fff" },
            { label: "Iconfarbe", key: "color-icon", value: "#fff" }
          ]
        }
      },
      events: {
        titel: "Events",
        widget: {
          title: "Events-Widget",
          colors: [
            { label: "Primärfarbe", key: "color-primary", value: "#00636C" },
            { label: "Textfarbe", key: "color-text", value: "#333" },
            { label: "Warnfarbe", key: "color-warning", value: "#c55c52" },
            {
              label: "Conversionfarbe",
              key: "color-conversion",
              value: "#d32f2f"
            }
          ]
        }
      },
      pois: {
        titel: "POIs",
        widget: {
          title: "POI-Widget",
          colors: [
            { label: "Primärfarbe", key: "color-primary", value: "#00636C" },
            {
              label: "Sekundärfarbe",
              key: "color-secondary",
              value: "#5d7114"
            },
            { label: "Textfarbe", key: "color-text", value: "#333" },
            { label: "Kontrastfarbe", key: "color-contrast", value: "#fff" }
          ]
        }
      },
      kis: {
        titel: "KIS",
        widget: {
          title: "KIS-Widget",
          colors: [
            { label: "Primärfarbe", key: "color-primary", value: "#00636C" },
            { label: "Textfarbe", key: "color-text", value: "#333" }
          ]
        }
      },
      forms: {
        titel: "Formulare",
        widget: {
          title: "Formular-Widget",
          colors: [
            { label: "Primärfarbe", key: "color-primary", value: "#97bd0f" },
            {
              label: "Sekundärfarbe",
              key: "color-secondary",
              value: "#5d7114"
            },
            { label: "Akzentfarbe", key: "color-accent", value: "#00636C" },
            { label: "Textfarbe", key: "color-text", value: "#333" },
            { label: "Infofarbe", key: "color-info", value: "#50727C" },
            { label: "Warnfarbe", key: "color-warning", value: "#E4CC37" },
            { label: "Fehlerfarbe", key: "color-error", value: "#ff0000" }
          ]
        }
      }
    },
    colorPaletteAIAssistentDialog: false,
    colorPaletteAIAssistentPromptLoading: false,
    colorPaletteAIAssistentSettings: {
      promptIds: {
        pictures: null,
        urls: null
      },
      data: {
        pictures: [],
        urls: []
      },
      action: "pictures"
    },
    newsConfig: null
  }),

  changed: false,
  methods: {
    addFeratelLogin() {
      Vue.set(this.feratelLogins, this.feratelLogins.length, {});
      this.$forceUpdate();
    },
    removeFeratelLogin(index) {
      Vue.delete(this.feratelLogins, index);
      this.$forceUpdate();
    },
    addFeratelCPSLogin() {
      Vue.set(this.editedItem.additional_data, "feratelCPSLogin", {
        feedUrl: ""
      });
      this.$forceUpdate();
    },
    removeFeratelCPSLogin() {
      Vue.delete(this.editedItem.additional_data, "feratelCPSLogin");
      this.$forceUpdate();
    },
    async loadAdvertisingZones() {
      const headers = getTokenHeader();
      const params = {
        ignorePrincipalId: 1,
        targets: ["app"]
      };
      const r = await axios.get(env.ad_manager_api_client_url + "ad/zones", {
        headers,
        params
      });
      this.advertisingZones = r.data ?? [];
    },
    getAdvertisingZoneItemText(zone) {
      const principal = this.principals.find(p => p.id === zone.principal_id);
      return `${zone.name} (${principal?.name ?? "---"})`;
    },
    addAppdinxLogin() {
      Vue.set(this.editedItem.additional_data, "appdinxLogin", {
        apiKey: "",
        apiId: "",
        apiDomain: "",
        fallbackPicture: {
          id: "",
          url: ""
        },
        advertising: {
          active: false,
          zones: {
            text1: null,
            text2: null,
            text3: null
          }
        }
      });
      this.$forceUpdate();
    },
    removeAppdinxLogin() {
      Vue.delete(this.editedItem.additional_data, "appdinxLogin");
      this.$forceUpdate();
    },
    addOutdoorActiveLogin() {
      Vue.set(this.editedItem.additional_data, "outdoorActiveLogin", {
        apiKey: "",
        project: "",
        defaultRegionAccessRight: "read"
      });
      this.$forceUpdate();
    },
    removeOutdoorActiveLogin() {
      Vue.delete(this.editedItem.additional_data, "outdoorActiveLogin");
      this.$forceUpdate();
    },
    addTraminoLogin() {
      if (!this.editedItem.additional_data.traminoLogin) {
        Vue.set(this.editedItem.additional_data, "traminoLogin", {});
        this.$forceUpdate();
      }
    },
    removeTraminoLogin() {
      const { pois, events } = this.editedItem.additional_data?.traminoLogin;
      if (!pois && !events) {
        Vue.delete(this.editedItem.additional_data, "traminoLogin");
      }
    },
    addTraminoLoginPOIs() {
      this.addTraminoLogin();
      Vue.set(this.editedItem.additional_data.traminoLogin, "pois", {
        apiKey: "",
        source: "",
        apiUrl: "",
        default_location: ""
      });
      this.$forceUpdate();
    },
    addTraminoLoginBergbahnStatus() {
      this.addTraminoLogin();
      Vue.set(this.editedItem.additional_data.traminoLogin, "bergbahnStatus", {
        description: "",
        apiKey: "",
        apiUrl: ""
      });
      this.$forceUpdate();
    },
    removeTraminoLoginPOIs() {
      Vue.delete(this.editedItem.additional_data.traminoLogin, "pois");
      this.removeTraminoLogin();
      this.$forceUpdate();
    },
    removeTraminoLoginBergbahnStatus() {
      Vue.delete(
        this.editedItem.additional_data.traminoLogin,
        "bergbahnStatus"
      );
      this.removeTraminoLogin();
      this.$forceUpdate();
    },
    addTraminoLoginEvents() {
      this.addTraminoLogin();
      Vue.set(this.editedItem.additional_data.traminoLogin, "events", {
        apiKey: "",
        source: "",
        apiUrl: "",
        default_location: ""
      });
      this.$forceUpdate();
    },
    removeTraminoLoginEvents() {
      Vue.delete(this.editedItem.additional_data.traminoLogin, "events");
      this.removeTraminoLogin();
      this.$forceUpdate();
    },
    addAllgaeuerZeitungLogin() {
      if (!this.allgaeuerZeitungLogin?.length) {
        Vue.set(this.editedItem.additional_data, "allgaeuerZeitungLogin", []);
      }
      this.allgaeuerZeitungLogin.push({
        feedUrl: "",
        trackingParameter: "",
        autoDeleteNews: true,
        deleteNewsAfter: 60,
        importFullArticle: false,
        defaultChannels: []
      });
      this.$forceUpdate();
    },
    removeAllgaeuerZeitungLogin(index) {
      if (!this.allgaeuerZeitungLogin?.length) {
        return;
      }
      this.allgaeuerZeitungLogin.splice(index, 1);
      this.$forceUpdate();
    },
    addNewsEmailImport() {
      if (!this.newsEmailImport) {
        Vue.set(this.editedItem.additional_data, "newsEmailImport", {
          sendToInbox: "",
          receiveFromWhiteList: [],
          approveImmediately: false,
          promptFeedId: ""
        });
      }
      this.$forceUpdate();
    },
    removeNewsEmailImport() {
      if (!this.newsEmailImport) {
        return;
      }
      Vue.delete(this.editedItem.additional_data, "newsEmailImport");
      this.$forceUpdate();
    },
    addDestinationOneLogin() {
      if (!this.editedItem.additional_data.destinationOneLogin) {
        Vue.set(this.editedItem.additional_data, "destinationOneLogin", {});
        this.$forceUpdate();
      }
    },
    addTravelLogin() {
      if (!this.editedItem.additional_data.travelLogin) {
        Vue.set(this.editedItem.additional_data, "travelLogin", {
          servicePackagesUrl: ""
        });
        this.$forceUpdate();
      }
    },
    removeTravelLogin() {
      const {
        servicePackagesUrl
      } = this.editedItem.additional_data?.travelLogin;
      if (!servicePackagesUrl) {
        Vue.delete(this.editedItem.additional_data, "travelLogin");
      }
    },
    addTravelAdWizardLogin() {
      if (!this.editedItem.additional_data.travelAdWizard) {
        Vue.set(this.editedItem.additional_data, "travelAdWizard", {
          active: 1,
          apiUrl: "",
          apiKey: "",
          travelPrincipalId: null
        });
        this.$forceUpdate();
      }
    },
    removeTravelAdWizardLogin() {
      const {
        active,
        apiUrl,
        apiKey,
        travelPrincipalId
      } = this.editedItem.additional_data?.travelAdWizard;
      if (!active && !apiUrl && !apiKey && !travelPrincipalId) {
        Vue.delete(this.editedItem.additional_data, "travelAdWizard");
      }
    },
    removeDestinationOneLogin() {
      const {
        pois,
        events
      } = this.editedItem.additional_data?.destinationOneLogin;
      if (!pois && !events) {
        Vue.delete(this.editedItem.additional_data, "destinationOneLogin");
      }
    },
    addEventimLogin() {
      if (!this.editedItem.additional_data.eventimLogin) {
        Vue.set(this.editedItem.additional_data, "eventimLogin", {
          active: true,
          zipRegions: []
        });
        this.$forceUpdate();
      }
    },
    removeEventimLogin() {
      if (!this.eventimLogin) {
        return;
      }
      Vue.delete(this.editedItem.additional_data, "eventimLogin");
      this.$forceUpdate();
    },
    addJobiqoLogin() {
      if (!this.editedItem.additional_data.jobiqoLogin) {
        Vue.set(this.editedItem.additional_data, "jobiqoLogin", {
          apiUrl: "",
          active: true
        });
        this.$forceUpdate();
      }
    },
    removeJobiqoLogin() {
      if (!this.jobiqoLogin) {
        return;
      }
      Vue.delete(this.editedItem.additional_data, "jobiqoLogin");
      this.$forceUpdate();
    },
    addDestinationOneLoginPOIs() {
      this.addDestinationOneLogin();
      Vue.set(this.editedItem.additional_data.destinationOneLogin, "pois", {
        apiUrl: "",
        experience: "",
        licenseKey: "",
        types: []
      });
      this.$forceUpdate();
    },
    removeDestinationOneLoginPOIs() {
      Vue.delete(this.editedItem.additional_data.destinationOneLogin, "pois");
      this.removeDestinationOneLogin();
      this.$forceUpdate();
    },
    addDestinationOneLoginEvents() {
      this.addDestinationOneLogin();
      Vue.set(this.editedItem.additional_data.destinationOneLogin, "events", {
        apiUrl: "",
        experience: "",
        licenseKey: "",
        types: []
      });
      this.$forceUpdate();
    },
    removeDestinationOneLoginEvents() {
      Vue.delete(this.editedItem.additional_data.destinationOneLogin, "events");
      this.removeDestinationOneLogin();
      this.$forceUpdate();
    },
    async updateCopyrightForPois(principalId, headers) {
      try {
        const res = await axios.get(
          `${env.poi_api_client_url}poi/updateCopyrightData?principal_id=${principalId}`,
          {
            headers
          }
        );
        this.changedCopyrightField = false;
        if (res.status !== 200) console.error(res.data.toString());
      } catch (e) {
        console.error(e);
      }
    },

    editCustomization() {
      this.customizeDialog = true;
      this.refreshKey++;
    },

    triggerDialog({ save, contentTypes, close }) {
      if (save && contentTypes?.length) {
        this.editedItem.newsContentTypes = contentTypes;
      }

      if (close) {
        this.customizeDialog = !this.customizeDialog;
        this.refreshKey++;
      }
    },

    async updateCopyrightForEvents(principalId, headers) {
      try {
        const res = await axios.get(
          `${env.events_api_client_url}allPrincipalEvents/updateCopyrightData?principal_id=${principalId}`,
          {
            headers
          }
        );
        this.changedCopyrightField = false;
        if (res.status !== 200) console.error(res.data.toString());
      } catch (e) {
        console.error(e);
      }
    },
    async checkAndCreateMapsConfig(principalId, headers) {
      try {
        const res = await axios.get(
          `${env.maps_api_client_url}config/?principal_id=${principalId}`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          try {
            await axios.post(
              `${env.maps_api_client_url}config/`,
              { principalId },
              { headers }
            );
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    async checkAndCreateEventConfig(principalId, headers) {
      try {
        await axios.get(
          `${env.events_api_client_url}config/?principal_id=${principalId}`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          try {
            await axios.post(
              `${env.events_api_client_url}config/`,
              { principalId },
              { headers }
            );
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    async checkAndCreateKisConfig(principalId, headers) {
      try {
        await axios.get(
          `${env.kis_api_client_url}config/?principal_id=${principalId}`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          try {
            await axios.post(
              `${env.kis_api_client_url}config/`,
              { principalId },
              { headers }
            );
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    async checkAndCreateBookingConfig(principalId, headers) {
      try {
        await axios.get(
          `${env.booking_api_client_url}config/?principal_id=${principalId}`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          try {
            await axios.post(
              `${env.booking_api_client_url}config/`,
              { principalId },
              { headers }
            );
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    async checkAndCreatePoiConfig(principalId, headers) {
      try {
        await axios.get(`${env.poi_api_client_url}config/${principalId}/`, {
          headers
        });
      } catch (error) {
        if (error.toString().includes("404")) {
          {
            await axios.post(
              `${env.poi_api_client_url}config/`,
              { _id: principalId },
              { headers }
            );
          }
        }
      }
    },
    async getNewsConfig() {
      const headers = getTokenHeader();
      const principalId = this.editedItem._id;
      try {
        const res = await axios.get(`${env.news_api_client_url}config`, {
          params: {
            principal_id: principalId
          },
          headers
        });
        return res.data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    getNewsChannelSelectTitle(channel) {
      const isActive = this.newsConfig.channels.includes(channel.value);
      const isDefault = this.newsConfig.default_channels.includes(
        channel.value
      );
      return `${channel.title} (Aktiv: ${isActive ? "Ja" : "Nein"}, Standard: ${
        isDefault ? "Ja" : "Nein"
      })`;
    },
    async checkAndCreateNewsConfig(principalId, headers) {
      try {
        await axios.get(`${env.news_api_client_url}config`, {
          params: {
            principal_id: principalId
          },
          headers
        });
      } catch (error) {
        if (error.toString().includes("404")) {
          {
            await axios.post(
              `${env.news_api_client_url}config/`,
              { principalId },
              {
                headers
              }
            );
          }
        }
      }
    },
    async checkAndCreateAdManagerConfig(principalId, headers) {
      try {
        await axios.get(
          `${env.ad_manager_api_client_url}config/${principalId}/`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          {
            await axios.post(
              `${env.ad_manager_api_client_url}config/`,
              { _id: principalId },
              {
                headers
              }
            );
          }
        }
      }
    },
    async checkAndCreateFormBuilderConfig(principalId, headers) {
      try {
        await axios.get(
          `${env.form_builder_api_client_url}api/config/${principalId}`,
          {
            headers
          }
        );
      } catch (error) {
        if (error.toString().includes("404")) {
          {
            await axios.post(
              `${env.form_builder_api_client_url}api/config/`,
              { principal_id: principalId },
              {
                headers
              }
            );
          }
        }
      }
    },
    async saveFileAccessSettings(editedItem) {
      const headers = getTokenHeader();

      try {
        await axios.put(
          `${env.file_client_url}v1/principalsettings`,
          {
            principalId: editedItem.id,
            lockByIpAddresses: editedItem.lockByIpAddresses,
            defaultLocked: editedItem.defaultLocked,
            ipWhitelist: editedItem.ipWhitelist
          },
          { headers }
        );
      } catch (err) {
        console.error(err);
        await this.$store.dispatch("createError", err.message);
      }
    },
    async save(closeDialog, editedItem) {
      const headers = getTokenHeader();
      await this.saveNikiRecipients();
      if (editedItem.id) {
        try {
          await this.saveFileAccessSettings(editedItem);
          if (this.appdinxLogin) {
            if (this.appdinxLogin.fallbackPicture instanceof File)
              this.appdinxLogin.fallbackPicture = await uploadFile(
                this.appdinxLogin.fallbackPicture,
                this.editedItem._id,
                "news",
                editedItem.id
              );
            delete this.appdinxLogin.fallbackPicture.title;
          }

          const response = await axios.put(
            `${env.auth_api_client_url}principals/update/${editedItem.id}`,
            editedItem,
            { headers }
          );
          await axios.patch(
            `${env.poi_api_client_url}config/${editedItem.id}`,
            { subPrincipals: editedItem.subPrincipals?.map(sp => sp._id) },
            { headers }
          );

          if (response.status === 200) {
            if (this.appdinxLoginAdvertisingChanged) {
              updateAllNewsInApp(editedItem.id, headers);
            }
            if (editedItem.modules.includes(this.modules.poi)) {
              await this.checkAndCreatePoiConfig(editedItem.id, headers);
              if (this.changedCopyrightField)
                await this.updateCopyrightForPois(editedItem.id, headers);
            }
            if (editedItem.modules.includes(this.modules.news))
              await this.checkAndCreateNewsConfig(editedItem.id, headers);
            if (editedItem.modules.includes(this.modules.maps)) {
              await this.checkAndCreateMapsConfig(editedItem.id, headers);
            }
            if (editedItem.modules.includes(this.modules.events)) {
              await this.checkAndCreateEventConfig(editedItem.id, headers);
              if (this.changedCopyrightField)
                await this.updateCopyrightForEvents(editedItem.id, headers);
            }
            if (editedItem.modules.includes(this.modules.adManager)) {
              await this.checkAndCreateAdManagerConfig(editedItem.id, headers);
            }
            if (closeDialog) this.close();
            this.createSuccess("Erfolgreich gespeichert");
            await this.$store.dispatch("getPrincipalList");

            const selectedPrincipal = this.principals.find(
              principal =>
                principal.id === this.$store.state.selectedPrincipal?.id
            );

            if (selectedPrincipal) {
              await this.$store.dispatch(
                "setSelectedPrincipal",
                selectedPrincipal
              );
              await this.$store.dispatch("getNavbarItems");
            }
          }
        } catch (err) {
          this.createError(err);
        }
      } else {
        try {
          if (this.appdinxLogin) {
            if (this.appdinxLogin.fallbackPicture instanceof File)
              this.appdinxLogin.fallbackPicture = await uploadFile(
                this.appdinxLogin.fallbackPicture,
                this.editedItem._id,
                "news",
                editedItem.id
              );
            delete this.appdinxLogin.fallbackPicture.title;
          }

          const response = await axios.post(
            `${env.auth_api_client_url}principals/add/`,
            editedItem,
            { headers }
          );
          if (response.status === 200) {
            editedItem.id = response.data.data.id;
            if (closeDialog) this.close();
            this.createSuccess("Erfolgreich gespeichert");
            await this.$store.dispatch("getPrincipalList");
          }
        } catch (err) {
          this.createError(err);
        }
      }
      if (!editedItem.id)
        this.createError("Keine Mandanten-ID zum prüfen der Modulconfigs");
      if (editedItem.modules.includes(this.modules.poi))
        await this.checkAndCreatePoiConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.news))
        await this.checkAndCreateNewsConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.events))
        await this.checkAndCreateEventConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.booking))
        await this.checkAndCreateBookingConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.maps)) {
        await this.checkAndCreateMapsConfig(editedItem.id, headers);
      }
      if (
        editedItem.modules.includes(this.modules.kis) ||
        editedItem.modules.includes(this.modules.defects)
      )
        await this.checkAndCreateKisConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.adManager))
        await this.checkAndCreateAdManagerConfig(editedItem.id, headers);
      if (editedItem.modules.includes(this.modules.formBuilder))
        await this.checkAndCreateFormBuilderConfig(editedItem.id, headers);
    },
    close() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = false;
      this.$refs.logOverview?.resetLogs();
    },
    async editItem(item) {
      this.editedItem = Object.assign(
        {},
        { ...this.defaultItem },
        { ...(item || {}) }
      );
      this.ensureColorPaletteStructure();

      this.dialog = true;
      await this.$store.dispatch("getRegions", {
        principalId: this.editedItem.id,
        ignorePrincipalId: 1
      });
      this.loadNikiRecipients();
      await this.loadLLMApiKeysForPrincipal();
    },
    getModuleCheckboxValue(moduleId, editedItem) {
      return editedItem?.modules?.includes(moduleId);
    },
    async addDropFile(e) {
      const file = e?.dataTransfer?.files ?? e ?? false;
      if (file) {
        file.dataUrl = await this.readFileUrl(file);
        file.title = file.name;

        const data = await uploadFile(
          file,
          undefined,
          "data",
          this.editedItem.id,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );
        if (data?.url) this.editedItem.logo = data.url;
      } else this.editedItem.logo = "";
    },
    async deleteLogo() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Logo löschen möchten?"
      );
      if (!isConfirmed) {
        return;
      }
      this.editedItem.logo = "";
    },
    setModuleCheckbox(moduleId, editedItem, checked) {
      if (checked && !editedItem.modules?.includes(moduleId))
        editedItem.modules.push(moduleId);
      else if (!checked && editedItem.modules?.includes(moduleId))
        editedItem.modules.remove(moduleId);

      this.editedItem = editedItem;
    },
    createError(ex) {
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      this.snackbar = true;
      console.error(ex);
    },
    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    },
    setExportConfig(exportConfig, index) {
      this.exportConfigs[index] = exportConfig;
      this.exportConfigs = [...this.exportConfigs];
      this.editedExportConfig = {};
      this.editedIndex = -1;
      this.exportPopupIsOpen = false;
    },
    addExportConfig() {
      this.exportConfigs.push({});
      this.exportConfigs = [...this.exportConfigs];
    },
    editExportConfig(exportConfig, index) {
      this.editedExportConfig = exportConfig;
      this.editedIndex = index;
      this.exportPopupIsOpen = true;
    },
    removeExportConfig(index) {
      this.$confirm(
        `Wollen Sie die Konfiguration wirklich löschen?`,
        confirmWarningConfig
      ).then(confirmRes => {
        if (confirmRes) {
          this.exportConfigs.splice(index, 1);
          this.exportConfigs = [...this.exportConfigs];
        }
      });
    },
    ensureColorPaletteStructure() {
      const defaultPalette = window.structuredClone(this.defaultColorPalette);
      const currentPalette = this.editedItem?.colorPalette;

      if (!currentPalette || Array.isArray(currentPalette)) {
        Vue.set(this.editedItem, "colorPalette", defaultPalette);
        return;
      }

      const normalizedPalette = {};

      for (const [moduleKey, moduleConfig] of Object.entries(defaultPalette)) {
        const currentModule = currentPalette?.[moduleKey] ?? {};

        normalizedPalette[moduleKey] = {
          titel:
            currentModule?.titel ??
            currentModule?.title ??
            moduleConfig?.titel ??
            moduleConfig?.title ??
            ""
        };

        for (const [widgetKey, widgetDefaultConfig] of Object.entries(
          moduleConfig
        ).filter(([, widgetConfig]) => Array.isArray(widgetConfig?.colors))) {
          const currentWidget = currentModule?.[widgetKey] ?? {};
          const currentColorsArray = Array.isArray(currentWidget.colors)
            ? currentWidget.colors
            : [];

          const mergedColors = widgetDefaultConfig.colors.map(defaultColor => {
            const currentColorEntry = currentColorsArray.find(
              color => color?.key === defaultColor.key
            );

            return {
              ...defaultColor,
              value: currentColorEntry?.value ?? defaultColor.value
            };
          });

          normalizedPalette[moduleKey][widgetKey] = {
            title:
              currentWidget?.title ??
              currentWidget?.titel ??
              widgetDefaultConfig.title ??
              widgetDefaultConfig.titel ??
              "",
            colors: mergedColors
          };
        }
      }

      // Avoid triggering render loops by only writing when the normalized
      // structure differs from the current reactive value.
      const currentPaletteString = JSON.stringify(currentPalette);
      const normalizedPaletteString = JSON.stringify(normalizedPalette);

      if (currentPaletteString === normalizedPaletteString) {
        return;
      }

      Vue.set(this.editedItem, "colorPalette", normalizedPalette);
    },
    getModuleColorPaletteTitle(moduleKey, moduleConfig) {
      return moduleConfig?.titel ?? moduleConfig?.title ?? moduleKey;
    },
    getColorPaletteWidgets(moduleConfig) {
      return Object.entries(moduleConfig || {}).filter(([, widgetConfig]) =>
        Array.isArray(widgetConfig?.colors)
      );
    },
    getColorPaletteValue(moduleKey, widgetKey, colorKey, fallbackColor) {
      this.ensureColorPaletteStructure();
      const colorEntry = this.editedItem?.colorPalette?.[moduleKey]?.[
        widgetKey
      ]?.colors?.find(color => color?.key === colorKey);
      return colorEntry?.value ?? fallbackColor;
    },
    setColorPaletteValue(moduleKey, widgetKey, colorKey, value) {
      this.ensureColorPaletteStructure();
      const colors = this.editedItem.colorPalette?.[moduleKey]?.[widgetKey]
        ?.colors;
      const index = Array.isArray(colors)
        ? colors.findIndex(color => color?.key === colorKey)
        : -1;

      if (index === -1) {
        return;
      }

      Vue.set(colors[index], "value", value);
    },
    setRegion(regionId, feratelLogin, currentRegionId) {
      if (feratelLogin.regions?.length) {
        const region = feratelLogin.regions.find(
          region => region.id === currentRegionId
        );
        region.id = regionId;
      } else feratelLogin.regions = [{ id: regionId }];
    },
    setLocationId: debounce(function(
      locationId,
      feratelLogin,
      currentRegionId
    ) {
      if (feratelLogin.regions?.length) {
        const region = feratelLogin.regions.find(
          region => region.id === currentRegionId
        );
        region.locationId = locationId;
      } else feratelLogin.regions = [{ locationId: locationId }];
    },
    500),
    getRegionsFromFeratelLogin(feratelLogin) {
      return feratelLogin?.regions ?? [{ id: "", locationId: "" }];
    },
    addRegion(feratelLogin) {
      if (!Array.isArray(feratelLogin.regions)) feratelLogin.regions = [];
      feratelLogin.regions.push({});
      this.$forceUpdate();
    },
    removeRegion(feratelLogin, index) {
      feratelLogin.regions.splice(index, 1);
      this.$forceUpdate();
    },
    async deletePrincipalData() {
      try {
        const isConfirmed = await this.$confirm(
          `Wollen Sie den Mandanten '${this.editedItem.name}' und alle dazugehörigen Datensätze wirklich löschen?`,
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          if (this.editedItem.modules.includes(this.modules.poi)) {
            await this.deletePois(headers);
          }
          if (this.editedItem.modules.includes(this.modules.booking)) {
            await this.deleteBookingModule(headers);
          }
          if (
            this.editedItem.modules.includes(this.modules.kis) ||
            this.editedItem.modules.includes(this.modules.defects)
          ) {
            await this.deleteKisModule(headers);
          }
          if (this.editedItem.modules.includes(this.modules.news)) {
            await this.deleteNews(headers);
          }
          if (this.editedItem.modules.includes(this.modules.events)) {
            await this.deleteEvents(headers);
          }
          if (this.editedItem.modules.includes(this.modules.locations)) {
            await this.deleteLocations(headers);
          }
          if (
            this.editedItem.modules.includes(this.modules.anzeigenassistent)
          ) {
            await this.deleteAdsPrincipal(headers);
          }
          await this.deletePrincipal(headers);
          await this.deletePromptConfig();
        }
        this.close();
      } catch (err) {
        await this.$store.dispatch("createError", err.message);
      }
    },
    async deletePrincipal(headers) {
      try {
        await axios.delete(`${env.auth_api_client_url}principals/delete`, {
          params: {
            id: this.editedItem._id,
            userId: this.$store.state.currentUser._id
          },
          headers
        });
      } catch (error) {
        console.error(error);
      }
    },
    async deleteBookingModule(headers) {
      try {
        await axios.delete(`${env.booking_api_client_url}deletePrincipal/`, {
          params: {
            principal_id: this.editedItem._id
          },
          headers
        });
      } catch (e) {
        console.error(e);
      }
    },
    async deleteKisModule(headers) {
      try {
        await axios.delete(`${env.kis_api_client_url}deletePrincipal/`, {
          params: { principal_id: this.editedItem._id },
          headers
        });
      } catch (e) {
        console.error(e);
      }
    },
    async deletePois(headers) {
      try {
        await axios.delete(`${env.poi_api_client_url}deletePrincipal/`, {
          params: {
            principal_id: this.editedItem._id
          },
          headers
        });
      } catch (error) {
        console.error(error);
      }
    },
    async deleteEvents(headers) {
      try {
        await axios.delete(`${env.events_api_client_url}allPrincipalEvents/`, {
          params: {
            principal_id: this.editedItem._id
          },
          headers
        });
      } catch (error) {
        console.error(error);
      }
    },
    async deleteNews(headers) {
      try {
        const params = {
          principal_id: this.editedItem._id
        };
        await axios.delete(`${env.news_api_client_url}allPrincipalNews`, {
          params,
          headers
        });
      } catch (error) {
        console.error(error);
      }
    },
    async deleteLocations(headers) {
      try {
        const params = {
          principal_id: this.editedItem._id
        };
        await axios.delete(
          `${env.locations_api_client_url}location/allPrincipalLocations`,
          {
            params,
            headers
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async deleteAdsPrincipal(headers) {
      try {
        const params = {
          principal_id: this.editedItem._id
        };
        await axios.delete(`${env.assistent_api_client_url}deletePrincipal`, {
          params,
          headers
        });
      } catch (error) {
        console.error(error);
      }
    },
    async applyFilter(filter) {
      if (!filter) filter = this.filter;
      if (filter.limit) delete filter.limit;
      await this.$store.dispatch("getPrincipalList", filter);
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.applyFilter(this.filter);
    }, 500),
    async addAppdinxFallbackPicture(e) {
      if (typeof this.appdinxLogin.fallbackPicture !== "object") {
        this.appdinxLogin.fallbackPicture = {};
      }
      const file = e?.dataTransfer?.files ?? e ?? false;
      if (file) {
        file.dataUrl = await this.readFileUrl(file);
        this.appdinxLogin.fallbackPicture = file;
      } else {
        this.appdinxLogin.fallbackPicture = {};
      }
    },
    async confirmRemoveImage() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Bild löschen möchten?",
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }

      const deleted = await destroyFile(
        "news",
        this.appdinxLogin.fallbackPicture.id
      );
      if (!deleted) {
        await this.$store.dispatch("createError", {
          text: "Bild konnte nicht gelöscht/gefunden werden!"
        });
        return;
      }
      this.appdinxLogin.fallbackPicture = {};
    },
    async fetchColorPaletteAIAssistantPrompts(force = false) {
      try {
        const headers = getTokenHeader();
        const defaultParams = {
          principal_id: this.$store.state.selectedPrincipal.id,
          module: "admin",
          force
        };

        const resPictures = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          {
            params: {
              ...defaultParams,
              action: "color_palette_from_picture"
            },
            headers
          }
        );
        this.colorPaletteAIAssistentSettings.promptIds.pictures =
          resPictures.data?.[0];

        const resUrls = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          {
            params: {
              ...defaultParams,
              action: "color_palette_from_url"
            },
            headers
          }
        );
        this.colorPaletteAIAssistentSettings.promptIds.urls = resUrls.data?.[0];
      } catch (e) {
        console.error("Fehler beim Laden der Prompts:", e);
      }
    },
    async addColorPaletteAIAssistentPicture(e) {
      const files = e?.currentTarget?.files ?? e?.dataTransfer?.files ?? e;
      if (files && files.length > 0) {
        this.colorPaletteAIAssistentSettings.data.pictures.push(...files);
      }
    },
    getJSONFromLLMResponse(str) {
      const jsonStr = str
        .replace("```json", "")
        .replace("```", "")
        .replace(/\n/g, "")
        .trim();
      try {
        const json = JSON.parse(jsonStr);
        return json;
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    getReferenceColorPalettePayload() {
      const toRemove = ["color-warning"];
      const payloadReferenceColorPalette = { ...this.colorPalette };
      Object.entries(payloadReferenceColorPalette).forEach(
        ([moduleKey, moduleConfig]) => {
          Object.entries(moduleConfig).forEach(([widgetKey, widgetConfig]) => {
            if (Array.isArray(widgetConfig.colors)) {
              payloadReferenceColorPalette[moduleKey][
                widgetKey
              ].colors = widgetConfig.colors.filter(
                color => !toRemove.includes(color.key)
              );
            }
          });
        }
      );
      return JSON.stringify(payloadReferenceColorPalette);
    },
    async executePromptWithPictures() {
      const imageUrls = await Promise.all(
        this.colorPaletteAIAssistentSettings.data.pictures.map(picture =>
          this.readFileUrl(picture)
        )
      );

      const {
        shortId,
        apiShortId
      } = this.colorPaletteAIAssistentSettings.promptIds.pictures;

      const payload = {
        apiShortId,
        promptShortId: shortId,
        principal_id: this.$store.state.selectedPrincipal.id,
        imageUrl: imageUrls,
        payload: `\nJSON: ${this.getReferenceColorPalettePayload()}`
      };

      const headers = getTokenHeader();

      const response = await axios.post(
        `${env.prompts_api_client_url}api/eo-prompt/execute-vision`,
        payload,
        {
          headers
        }
      );

      const data = response.data.choices[0].message.content;
      const json = this.getJSONFromLLMResponse(data);

      if (json) {
        return json;
      } else {
        console.error("Fehler beim Parsen der JSON-Antwort:", response.data);
      }
    },
    async executePrompt() {
      const {
        shortId,
        apiShortId
      } = this.colorPaletteAIAssistentSettings.promptIds.urls;

      const headers = getTokenHeader();

      const body = {
        apiShortId,
        promptShortId: shortId,
        principal_id: this.$store.state.selectedPrincipal.id,
        payload: `JSON:\n${this.getReferenceColorPalettePayload()}\nURLs:\n${JSON.stringify(
          this.colorPaletteAIAssistentSettings.data.urls.join("\n")
        )}`
      };

      const res = await axios.post(
        `${env.prompts_api_client_url}api/eo-prompt/exec`,
        body,
        {
          headers
        }
      );

      const json = this.getJSONFromLLMResponse(res.data?.text);
      if (json) {
        return json;
      } else {
        console.error("Fehler beim Parsen der JSON-Antwort:", res.data);
      }
    },
    async openColorPaletteAIAssistentDialog() {
      this.colorPaletteAIAssistentSettings.data = {
        pictures: [],
        urls: []
      };

      this.colorPaletteAIAssistentDialog = true;
      if (
        !this.colorPaletteAIAssistentSettings.promptIds.urls &&
        !this.colorPaletteAIAssistentSettings.promptIds.pictures
      ) {
        await this.fetchColorPaletteAIAssistantPrompts();
        if (
          !this.colorPaletteAIAssistentSettings.promptIds.urls &&
          !this.colorPaletteAIAssistentSettings.promptIds.pictures
        ) {
          await this.$store.dispatch("createError", {
            text:
              "Prompts konnten nicht geladen werden. Prüfen Sie die Konfiguration."
          });
          this.colorPaletteAIAssistentDialog = false;
        }
      }
    },
    async colorPaletteAIAssistent() {
      let result;
      try {
        this.colorPaletteAIAssistentPromptLoading = true;

        const { data, action } = this.colorPaletteAIAssistentSettings;
        if (action === "pictures" && data.pictures.length) {
          result = await this.executePromptWithPictures();
        }
        if (action === "urls" && data.urls.length) {
          result = await this.executePrompt();
        }
      } finally {
        this.colorPaletteAIAssistentPromptLoading = false;
      }

      if (result) {
        this.colorPalette = Object.assign(this.colorPalette, result);
        await this.createSuccess("Farbpalette erfolgreich generiert.");
      } else {
        this.$store.dispatch("createError", {
          text:
            "Es konnte keine Farbpalette anhand Ihrer Daten generiert werden."
        });
      }

      this.colorPaletteAIAssistentDialog = false;
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = ({ target }) => {
          if (target?.result) resolve(target.result);
          else reject("Unable to read File");
        };
        reader.readAsDataURL(file);
      });
    },
    addNikiRecipients() {
      this.showNikiRecipients = true;
    },
    removeNikiRecipients() {
      this.showNikiRecipients = false;
      this.nikiRecipients = "";
    },
    async loadNikiRecipients() {
      try {
        const headers = getTokenHeader();
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/config`,
          { params: { principal_id: this.editedItem.id }, headers }
        );

        const recipients = res.data?.recipients || "";
        this.nikiRecipients = recipients;
        this.showNikiRecipients = recipients.length > 0;

        if (res.data?.isChatbotEnabled) {
          this.editedItem.isChatbotEnabled = true;
          this.editedItem.chatbotApiKey = res.data?.chatbotApiKey || "";
        }
      } catch (err) {
        console.error("Failed loading NIKI recipients", err);
      }
    },

    async saveNikiRecipients() {
      if (!this.nikiRecipients && !this.editedItem.isChatbotEnabled) return;

      try {
        const headers = getTokenHeader();
        const payload = {
          principal_id: this.editedItem.id,
          recipients: this.nikiRecipients
        };

        if (this.editedItem.isChatbotEnabled) {
          payload.isChatbotEnabled = true;
          payload.chatbotApiKey = this.editedItem.chatbotApiKey;
        }

        await axios.post(
          `${env.prompts_api_client_url}api/eo-prompt/config`,
          payload,
          { headers }
        );
        //this.createSuccess("NIKI Empfänger gespeichert");
      } catch (err) {
        console.error("Failed saving NIKI recipients", err);
        this.createError(err);
      }
    },

    async deletePromptConfig() {
      try {
        const headers = getTokenHeader();
        await axios.delete(
          `${env.prompts_api_client_url}api/eo-prompt/config`,
          {
            params: { principal_id: this.editedItem.id },
            headers
          }
        );
        this.nikiRecipients = "";
        this.showNikiRecipients = false;
      } catch (err) {
        console.error("Failed deleting prompt config", err);
        this.createError(err);
      }
    },
    async fetchPromptFeeds() {
      try {
        const headers = getTokenHeader();
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/feeds`,
          { headers }
        );
        this.promptFeeds = res.data;
      } catch (err) {
        console.error("Failed to fetch feeds:", err);
      }
    },
    async fetchLLMApiKeys() {
      try {
        await this.$store.dispatch("getLLMApiKeys");
        this.llmApiKeys = this.$store.state.llmApiKeys || [];
      } catch (err) {
        console.error("Failed to fetch LLM API keys:", err);
      }
    },
    async loadLLMApiKeysForPrincipal() {
      try {
        const headers = getTokenHeader();
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/admin`,
          {
            params: {
              principal_id: this.editedItem.id
            },
            headers
          }
        );
        this.llmApiKeys = response.data || [];
      } catch (err) {
        console.error("Failed to fetch LLM API keys for principal:", err);
      }
    },
    getLLMApiKeyDisplayText(item) {
      return item?.description?.trim() ? item.description : item.apiKey;
    }
  },
  computed: {
    users() {
      return this.$store.state.users;
    },
    principalObjects() {
      if (!this.editedItem.subPrincipals) return [];
      return [
        ...this.editedItem.subPrincipals,
        { _id: this.editedItem._id, name: this.editedItem.name }
      ];
    },
    principals() {
      const principals = this.$store.state.principalList;
      principals.forEach(principal => {
        // If the principal has a parant, it is a subPrincipal
        principal.isSub = !!principal.parent;
      });
      return principals;
    },
    poiImageTypes: {
      get() {
        return this.editedItem?.poiImageTypes ?? [];
      },
      set(value) {
        this.editedItem.poiImageTypes = value;
      }
    },
    poiFileTypes: {
      get() {
        return this.editedItem?.poiFileTypes ?? [];
      },
      set(value) {
        this.editedItem.poiFileTypes = value;
      }
    },
    principalOwnPoiCategoryTypes() {
      return this.$store.state.categoryTypes;
    },
    principalOwnPoiFeatureGroups() {
      return this.$store.state.featureGroups;
    },
    exportConfigs: {
      get() {
        return this.editedItem?.exportConfigs ?? [{}];
      },
      set(value) {
        this.editedItem.exportConfigs = value;
      }
    },
    colorPalette: {
      get() {
        this.ensureColorPaletteStructure();
        return this.editedItem?.colorPalette ?? {};
      },
      set(value) {
        this.editedItem.colorPalette = value;
      }
    },
    feratelLogins: {
      get() {
        if (
          !this.editedItem?.additional_data?.feratelLogins ||
          !Array.isArray(this.editedItem?.additional_data?.feratelLogins)
        )
          this.editedItem.additional_data.feratelLogins = [{}];
        return this.editedItem?.additional_data?.feratelLogins;
      },
      set(value) {
        this.editedItem.additional_data.feratelLogins = value;
      }
    },
    feratelCPSLogin() {
      return this.editedItem?.additional_data?.feratelCPSLogin;
    },
    appdinxLogin() {
      return this.editedItem?.additional_data?.appdinxLogin;
    },
    appdinxLoginAdvertisingChanged() {
      if (!this.appdinxLogin?.advertising) {
        return false;
      }

      const current = this.appdinxLogin.advertising;
      const initial = this.appdinxLoginInitialAdvertising;
      if (current.active !== initial.active) {
        return true;
      }

      for (const key of ["text1", "text2", "text3"]) {
        if (current.zones[key] !== initial.zones[key]) {
          return true;
        }
      }

      return false;
    },
    outdoorActiveLogin() {
      const outdoorActiveLogin = this.editedItem?.additional_data
        ?.outdoorActiveLogin;
      if (outdoorActiveLogin) {
        if (!outdoorActiveLogin.exportPoisFeature) {
          outdoorActiveLogin.exportPoisFeature = "";
        }
      }
      return outdoorActiveLogin;
    },
    outdoorActiveExportOwnerDefaultValue() {
      return this.editedItem.name?.toLowerCase()?.replace(/\s/g, "-");
    },
    traminoLoginEvents() {
      return this.editedItem?.additional_data?.traminoLogin?.events;
    },
    traminoLoginPOIs() {
      return this.editedItem?.additional_data?.traminoLogin?.pois;
    },
    traminoLoginBergbahnStatus() {
      return this.editedItem?.additional_data?.traminoLogin?.bergbahnStatus;
    },
    allgaeuerZeitungLogin() {
      return this.editedItem?.additional_data?.allgaeuerZeitungLogin;
    },
    newsChannels() {
      if (!this.newsConfig) {
        return;
      }
      return [
        { header: "Standard Kanäle" },
        ...this.newsConfig.standard_channels.map(channel => ({
          ...channel,
          selectText: this.getNewsChannelSelectTitle(channel)
        })),
        { divider: true },
        { header: "Eigene Kanäle" },
        ...this.newsConfig.own_channels.map(channel => ({
          ...channel,
          selectText: this.getNewsChannelSelectTitle(channel)
        }))
      ];
    },
    newsEmailImport() {
      return this.editedItem?.additional_data?.newsEmailImport;
    },
    destinationOneLogin() {
      return this.editedItem?.additional_data?.destinationOneLogin;
    },
    destinationOneLoginPOIs() {
      const destinationOneLoginPOIs = this.destinationOneLogin?.pois;
      if (!destinationOneLoginPOIs) {
        return undefined;
      }
      const fields = ["apiUrl", "experience", "licenseKey", "source"];
      if (fields.every(key => !Object.hasOwn(destinationOneLoginPOIs, key))) {
        return undefined;
      }
      return destinationOneLoginPOIs;
    },
    destinationOneLoginEvents() {
      const destinationOneLoginEvents = this.destinationOneLogin?.events;
      if (!destinationOneLoginEvents) {
        return undefined;
      }
      const fields = ["apiUrl", "experience", "licenseKey", "source"];
      if (fields.every(key => !Object.hasOwn(destinationOneLoginEvents, key))) {
        return undefined;
      }
      return destinationOneLoginEvents;
    },
    travelAdWizardLogin() {
      const travelAdWizard = this.editedItem?.additional_data?.travelAdWizard;
      if (!travelAdWizard) {
        return undefined;
      }
      const fields = ["active", "apiUrl", "apiKey", "travelPrincipalId"];
      if (fields.every(key => !Object.hasOwn(travelAdWizard, key))) {
        return undefined;
      }
      return travelAdWizard;
    },
    travelLogin() {
      const travelLogin = this.editedItem?.additional_data?.travelLogin;
      if (!travelLogin) {
        return undefined;
      }
      const fields = ["servicePackagesUrl"];
      if (fields.every(key => !Object.hasOwn(travelLogin, key))) {
        return undefined;
      }
      return travelLogin;
    },
    eventimLogin() {
      return this.editedItem?.additional_data?.eventimLogin;
    },
    jobiqoLogin() {
      return this.editedItem?.additional_data?.jobiqoLogin;
    },
    regions() {
      return this.$store.state.regions;
    },
    logUrl() {
      return `${env.auth_api_client_url}log/${this.editedItem.id}`;
    }
  },
  async mounted() {
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    try {
      this.isLoading = true;
      await this.applyFilter(this.filter);
      await this.fetchPromptFeeds();
      await this.fetchLLMApiKeys();
      await this.loadAdvertisingZones();
      await this.$store.dispatch("getCategoryTypes");
      await this.$store.dispatch("getFeatureGroupsForPois");
      //await this.$store.dispatch("getRegions", { ignorePrincipalId: 1 });
      this.isLoading = false;
    } catch (err) {
      await this.$store.dispatch("createError", err.message);
      this.isLoading = false;
    }
  },
  watch: {
    async dialog(value) {
      if (value) {
        await this.$store.dispatch("getAllUsers", {
          deleted: 0,
          principal_id: this.editedItem.id
        });
        this.appdinxLoginInitialAdvertising = window.structuredClone(
          this.appdinxLogin?.advertising
        );
        this.newsConfig = await this.getNewsConfig();
      }
    }
  }
};
